<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <h1 class="title">{{ "Add Booth" | translate }}</h1>
            <button mat-icon-button mat-dialog-close aria-label="Close dialog" (click)="matDialogRef.close()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 m-0 primary-50" fusePerfectScrollbar>
        <form
            name="form"
            [formGroup]="form"
            (ngSubmit)="form.valid && onSubmit()"
          >
        <mat-form-field appearance="outline" color="accent" class="form-group">
            <mat-label>{{ "Booth Name" | translate }}</mat-label>
            <input autocomplete="off" matInput name="booth" class="form-control"
            formControlName="booth" [ngClass]="{
                'is-invalid': form.get('booth').touched && form.get('booth').invalid
              }"
              required />
            <mat-error>Enter or choose valid amount</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent" class="form-group">
            <mat-label>{{ "Booth Area" | translate }}</mat-label>
            <input autocomplete="off" matInput name="area" class="form-control"
            formControlName="area" [ngClass]="{
                'is-invalid': form.get('area').touched && form.get('area').invalid
              }"
              required />
            <mat-error>Enter or choose valid amount</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent" class="form-group">
            <mat-label>{{ "Booth Number" | translate }}</mat-label>
            <input type="number" autocomplete="off" matInput name="booth_number" class="form-control"
            formControlName="booth_number" [ngClass]="{
                'is-invalid': form.get('booth_number').touched && form.get('booth_number').invalid
              }"
              required />
            <mat-error>Enter or choose valid amount</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent" class="form-group">
            <mat-label>{{ "Total Voters" | translate }}</mat-label>
            <input type="number" autocomplete="off" matInput name="total_voters" class="form-control"
            formControlName="total_voters" [ngClass]="{
                'is-invalid': form.get('total_voters').touched && form.get('total_voters').invalid
              }"
              required />
            <mat-error>Enter or choose valid amount</mat-error>
        </mat-form-field>
        <div class="mt-12" style="text-align: center;">
            <button mat-raised-button class="mr-4 green-600" 
        [disabled]="!form.valid" (click)="submit()"
        >சேமி</button>
            <button mat-raised-button class="red" (click)="matDialogRef.close()">
                ரத்துசெய்</button>
        </div>
        </form>
    </div>

    <!-- <div class="footer">
        <button mat-raised-button class="accent">
            {{ "Save" | translate }}
        </button>
        <button mat-raised-button class="red">
            {{ "Go Back" | translate }}
        </button>
    </div> -->
</div>